import type { SidePanelFooterWrapperProps } from "./side-panel-footer.type";

import SidePanelFooter from "./side-panel-footer.component";

const SidePanelFooterWrapper = ({
  position = "sticky-bottom",
  children,
}: SidePanelFooterWrapperProps) => {
  if (position === "follow-content") {
    return <div className="side-panel-footer_follow-content">{children}</div>;
  }

  return (
    <SidePanelFooter>
      <div className="side-panel-footer_sticky-bottom">{children}</div>
    </SidePanelFooter>
  );
};

export default SidePanelFooterWrapper;
